import { useSelector } from "react-redux";
import type { RootState } from "../../store";
import type { Project, Client } from "../../generated-axios-client";

type ProjectsState = {
  projects: Project[];
  clientById: Record<string, Client>;
  loading: boolean;
  error: string | null;
};

export function useDashboardProjects(): ProjectsState {
  const projects = useSelector((state: RootState) => state.dashboard.projects);
  const clientById = useSelector((state: RootState) => state.dashboard.clientById);
  const loading = useSelector((state: RootState) => state.dashboard.loading);
  const error = useSelector((state: RootState) => state.dashboard.error);
  return { projects, clientById, loading, error };
}
